import { Suspense } from 'react';

import { SplashScreen } from '@/shared/ui/components/SplashScreen';

import { MainComposition } from './di/compositions/Main';
import { useVitePreloadError } from './hooks/useVitePreloadError';
import { useYandexMetrika } from './hooks/useYandexMetrika';
import { Router } from './router';

/** Корневой компонент */
const App = () => {
  useYandexMetrika();
  useVitePreloadError();

  return (
    <MainComposition>
      <Suspense fallback={<SplashScreen />}>
        <Router />
      </Suspense>
    </MainComposition>
  );
};

export default App;
